<div class="list-group-item list-group-item-action clickable" [ngClass]="{'active': isActive}">
  <div (click)="onNodeClicked(node)"><span class="fa fa-plus-circle"></span> {{node.data.name}}</div>
  <div class="list-group" *ngIf="node.children && node.children.length">
    <org-unit-node *ngFor="let child of node.children" [node]="child" (onClicked)="onNodeClicked($event)"></org-unit-node>
  </div>
</div>
